import {
  HttpClient,
  HttpEvent,
  HttpHeaderResponse,
  HttpHeaders,
  HttpParams,
  HttpProgressEvent, HttpResponse,
  HttpSentEvent, HttpUserEvent, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core'
import {BehaviorSubject, Observable, Subject, throwError} from 'rxjs';
import * as environmentUrl from 'src/environments/environment';
import {catchError} from "rxjs/operators";

interface BackendMessageResponse {
  id: number;
  type: string;
  text: string;
  market: string;
  language: string;
  textColor?: string;
  createdTime: string;
  updatedTime: string;
  createdBy?: string;
  updatedBy?: string;
  batchUuid?: string;
  editable: boolean;
  attachmentFilename?: string;
  attachmentContentType?: string;
  originalFilename?: string;
}

interface WhatsNewMessageRequest {
  type: string;
  text: string;
  market: string;
  language: string;
  textColor: string;
  createdBy: string;
  updatedBy: string;
  attachmentFilename?: string;
  attachmentContentType?: string;
  originalFilename?: string;
  removeAttachment?: boolean;
}

interface GtacTemplateDto {
  fileName: string;
  createdBy: string;
  timestamp: string;
  notes: string;
  isActive: Boolean;
  uuid: string;
}

@Injectable({
  providedIn: 'root'
})
export class ApifirstService {
  public show_Another_App_Active_popup = new BehaviorSubject('ValuesNotSet');
  public ruleId = new BehaviorSubject('')
  public WDCListservice = new BehaviorSubject([])
  public vindetail = new BehaviorSubject({});
  public tokenObj = new BehaviorSubject({});
  public isNetorkTest = new BehaviorSubject(false);
  public isFDRSNetworkTest$ = new Subject<object>();
  public symptomSubject = new BehaviorSubject(0);
  public listsymptomSubject = new BehaviorSubject([0]);
  public identifyDetails = new BehaviorSubject({});
  public ParentsymptomSubject = new BehaviorSubject([0]);
  public tempSymptomSubject = new BehaviorSubject([0]);
  public navigateSymptom = new BehaviorSubject('');
  public symptomName = new BehaviorSubject('');
  public queryParams: any;
  public userId = new BehaviorSubject('');
  public showNoconnection = new BehaviorSubject(false);
  public fromCapture = new BehaviorSubject(false);
  public isSymptomClickHereLinkEmpty = new BehaviorSubject(false);
  public tokenVinNum = new BehaviorSubject('');
  public infotab = new BehaviorSubject(false);
  public hintstab = new BehaviorSubject(false);
  public submittab = new BehaviorSubject(false);
  public isRepairProcedure = new BehaviorSubject(false);
  public isPostRepairProcedure = new BehaviorSubject(false);
  public showSBDAdminTab = new BehaviorSubject(false);
  public showAdminTab = new BehaviorSubject(false);
  public candidateId = new BehaviorSubject('');
  public candidateKind = new BehaviorSubject('');
  public candidateProcUid = new BehaviorSubject('');
  public candidateUidRef = new BehaviorSubject('');
  public propertyData = new BehaviorSubject([]);
  public IDpropertyData = new BehaviorSubject(0);
  public isFDRSConnection = new BehaviorSubject(false);
  public isProgressBar = new BehaviorSubject(false);
  public serviceName = new BehaviorSubject('')
  public globalServicesId = new BehaviorSubject(0)
  public editServiceId = new BehaviorSubject(0)
  public selectedDiagnosticProcedureData$ = new BehaviorSubject([{}]);
  public diagnosticViewFaultFound = new BehaviorSubject({
    "status": '',
    "isFound": false,
    "faultString": ''
  });
  public existingSessionData = new BehaviorSubject<any>(null);
  public passApiResp = new BehaviorSubject({});
  public isEditRecurringRule = new BehaviorSubject(false);
  public isEditonOff = new BehaviorSubject(false);
  public navigatetoPreviousScreen = new BehaviorSubject({});
  public repairObj = new BehaviorSubject([{}])
  public postRepairObj = new BehaviorSubject([{}])
  public control = new BehaviorSubject(false);
  public fromResume = new BehaviorSubject(false);
  public resumeRVC = new BehaviorSubject(false);
  public pageData = new BehaviorSubject('');
  public sId = new BehaviorSubject('');
  public recurringRes = new BehaviorSubject({})
  public oneOffRes = new BehaviorSubject({})
  public vehicleDetails = new BehaviorSubject({});
  public navigatePreviousScreen = new BehaviorSubject('');
  public storeGidPostRepair = new BehaviorSubject([]); // check the test button click and enable/hide Go button in repir qualification page.
  public storeGidRepair = new BehaviorSubject([]);  // check the test button click and enable/hide Go button in repir qualification page.
  public serviceNameListservice = new BehaviorSubject([])
  public selectedGlobalServices = new BehaviorSubject('');
  public isShowFDRSVersionInCompatableMsg = new BehaviorSubject({})
  public otxStateChangeObj = new BehaviorSubject([{}])
  public getSelectedDiagProcdureId = new BehaviorSubject('');
  public isShowFDRSLoader = new BehaviorSubject(true)
  public sessionData = new BehaviorSubject([])
  public isFromRepairComplete = new BehaviorSubject(false)
  public rapToken = new BehaviorSubject("")
  public repairQualificationData = new BehaviorSubject({})
  public isSessionCreated = new BehaviorSubject(false)
  public isNetworkTestCompletedFromResume = new BehaviorSubject(false)
  public showOtxSpinner = new BehaviorSubject(false);
  public RAPSubmitBtnStatus = new BehaviorSubject(false);
  public isNWTInProgress = new BehaviorSubject('');
  public isHomeNWTBtnCilcked = new BehaviorSubject(false);
  public showOTXErrorPopUp = new BehaviorSubject<object>({})
  public sendGnumberToRAP = new BehaviorSubject('');
  public isShowRAP = new BehaviorSubject(true);
  public getWebsocketStatus = new BehaviorSubject('test')
  public freshWebSocketConnStatus = new BehaviorSubject('test')
  public getWebsocketStatusonStartUpComp = new BehaviorSubject('test')
  public freshWebSocketConnStatusonStartUpComp = new BehaviorSubject('test');
  public getFDRSStatusInDiagnostic = new BehaviorSubject('test');
  public OTXinvalidAppSkipTest = new BehaviorSubject({});
  public captureCustomerComments = new BehaviorSubject({})
  public enableFDRSVersionEditPermissionInAdhoc = new BehaviorSubject(false);
  public showMoreDiagnosticHWReqText = new BehaviorSubject(false);
  public scheduleJobStatusMessage = new BehaviorSubject('');
  public showDataCollectorCheckBox = new BehaviorSubject(false);
  public dataCollectorInfo = new BehaviorSubject('FULL');
  public showDataCollectorsBtn = new BehaviorSubject(false);
  public HighlightAddManageWarrantyCode = new BehaviorSubject(false);
  public loginUserId = new BehaviorSubject('');
  public fdrsErorCode = new Subject<string>();
  public fdrsConnectionStatus = new Subject<boolean>();
  public showTempDealerBtn = new BehaviorSubject(false);
  public tempDealerCode = new BehaviorSubject('null')
  private vinDetails$ = new BehaviorSubject<any>(null);
  public userRoles$ = new BehaviorSubject<string[]>([]);

  setUserRoles(roles: string[]) {
    this.userRoles$.next(roles);
  }
  setVinDetails(details: any) { this.vinDetails$.next(details); }
  getVinDetailsSnapshot(): any {
    return this.vinDetails$.getValue();
  }
// no snapshot method

  constructor(private http: HttpClient) {
  }
  public baseUrl = environmentUrl.environment.baseUrl;
  public rapUrl = environmentUrl.environment.rapUrl
  public idsUrl = environmentUrl.environment.idsUrl;
  public automatedUrl = environmentUrl.environment.automatedUrl;
  public schUrl = environmentUrl.environment.schUrl;
  public gtacUrl = environmentUrl.environment.gtacUrl;
  public userName = new BehaviorSubject('');
  public userType = new BehaviorSubject('');
  public header: any;
  public rapheader: any;
  public tokenDet: any;
  private _showWhatsNew = new BehaviorSubject<boolean>(true);
  readonly showWhatsNew$ = this._showWhatsNew.asObservable();
  setHeaders() {
    let type;
    let userName;
    this.userType.subscribe(data => { type = data })
    this.userName.subscribe(data => { userName = data })
    this.rapToken.subscribe((data) => {
      this.tokenDet = data;
    })
    let usertype;
    if (type == 'FORD_INTERNAL') {
      usertype = '1';
    }
    else if (type === 'PTS_AFTERMARKET') {
      usertype = '2';
    }
    else {
      usertype = '3';
    }

    this.header = {
      headers: new HttpHeaders()
        .set('USER_TOKEN', `${btoa(userName + usertype + ':')}`)
        .set('Authorization', 'Bearer ' + this.tokenDet)
    };

    this.rapheader = {
      headers: new HttpHeaders()
        .set('FDSP_TOKEN', this.tokenDet)
    }
  }


  getSymptoms(language: any, country: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + 'sbdo/all-symptoms/' + language + '/' + country, this.header);
  }
  changeSymptomApi(sessionid: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/change-symptom/" + sessionid, this.header);
  }

  insertSymptoms(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + 'sbdo/customer-comment', req, this.header);
  }
  tokenValidationRequest(userDetailsToken: any): Observable<any> {
    return this.http.post(this.baseUrl + 'sbdo/validate-fdsp-token', userDetailsToken, {
      headers: new HttpHeaders()
        .set('Authorization', `Basic ${btoa('default1:')}`)
    });
  }
  tokenValidationWithToken(userName: string, userType: any, userDetailsToken: any): Observable<any> {
    let username = userName;
    let type = userType;
    let usertype;
    if (type === 'FORD_INTERNAL') {
      usertype = '1';
    }
    else if (type === 'PTS_AFTERMARKET') {
      usertype = '2';
    }
    else {
      usertype = '3';
    }
    const headers = new HttpHeaders()
      .set('USER_TOKEN', `${btoa(username + usertype + ':')}`).set('Authorization', 'Bearer ' + userDetailsToken);
    return this.http.post(this.baseUrl + 'sbdo/validate-fdsp-token', userDetailsToken, { headers: headers });
  }
  createSession(req: any): Observable<any> {
    this.setHeaders();
    console.log(this.baseUrl, 'Base URL create session');
    return this.http.post<any>(this.baseUrl + 'sbdo/create-session', req, this.header);
  }

  getVariantSummaryDetails(variantObj: Number): Observable<any> {
    this.setHeaders();
    return this.http.get(this.baseUrl + 'sbdo/list-of-procedure/' + variantObj, this.header);
  }

  getVariantDetails(): Observable<any> {
    this.setHeaders();
    return this.http.get(this.baseUrl + 'sbdo/list-of-variant/en/US', this.header);
  }
  getRegdetails(vin: any): Observable<any> {
    this.setHeaders();
    let str = this.baseUrl + "sbdo/vin2reg/vin?vin=" + vin.vin + "&dealerCode=" + vin.dealerCode
    return this.http.get(str, this.header);
  }

  getIdentifydetails(identifyObj: any): Observable<any> {
    this.setHeaders();
    let str = this.baseUrl + "sbdo/getIdentifyFailureGroup?vin=" + identifyObj.vin + "&filter=" + identifyObj.filtered + "&diagnostic=" + identifyObj.diagnostic +
      "&userId=" + identifyObj.userId + "&userType=" + identifyObj.userType + "&languageCode=" + identifyObj.languageCode + "&countryCode=" + identifyObj.countryCode +
      "&sessionId=" + identifyObj.sessionId
    return this.http.get(str, this.header);
  }

  getSectionList(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + "sbdo/getSectionDetails", req, this.header)
  }

  getComponentList(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + "sbdo/getComponent", req, this.header)
  }

  getSelectedList(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + "sbdo/getSelected", req, this.header)
  }

  getConfirmstatusInIdentifyFailure(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + "sbdo/getConfirm", req, this.header)
  }

  getRegistrationnumber(reg: any): Observable<any> {
    this.setHeaders();
    let str = this.baseUrl + "sbdo/vin2reg/reg?reg=" + reg.registration + "&dealerCode=" + reg.dealerCode
    return this.http.get(str, this.header);
  }

  selectedSymptoms(selectedIdandsession: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + 'sbdo/session-symptom', selectedIdandsession, this.header)
  }

  requestUserRoles(userObj: any): Observable<any> {
    console.log(this.baseUrl, 'Base URL User Role');
    return this.http.post(this.baseUrl + 'sbdo/login-user', userObj, {
      headers: new HttpHeaders()
        .set('Authorization', `Basic ${btoa('default1:')}`)
    });
  }
  requestUserRolesWithToken(userName: string, userType: any, userObj: any): Observable<any> {
    let username = userName;
    let type = userType;
    let usertype;
    let fdspToken;
    this.rapToken.subscribe((data) => {
      fdspToken = data
    })
    if (type === 'FORD_INTERNAL') {
      usertype = '1';
    }
    else if (type === 'PTS_AFTERMARKET') {
      usertype = '2';
    }
    else {
      usertype = '3';
    }
    const headers = new HttpHeaders()
      .set('USER_TOKEN', `${btoa(username + usertype + ':')}`).set('Authorization', 'Bearer ' + fdspToken);

    console.log(this.baseUrl, 'Base URL User Role');
    return this.http.post(this.baseUrl + 'sbdo/login-user', userObj, {
      headers: headers
    });
  }

  getVindetails(vin: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + 'sbdo/vin-to-vehicle-desc', vin, this.header);
  }

  setQualifiedUserDetails(qualifier1: any): Observable<any> {
    this.setHeaders();
    let str = this.baseUrl + 'sbdo/list-of-roles/' + qualifier1.qualifier
    return this.http.get(str, this.header);
  }

  setQueryParams(queryParams: any) {
    this.queryParams = queryParams;
  }
  getQueryParams() {
    return this.queryParams;
  }

  getTargetEngineStatusDetails(): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + 'sbdo/status', this.header);
    // {
    //   headers: new HttpHeaders()
    //     .set('Authorization', `Basic ${btoa('user:password')}`)
    // });
  }
  getPingStatusDetails(): Observable<any> {
    this.setHeaders();
    return this.http.get<string>(this.baseUrl + 'rest/knowledgebase/ping', this.header);
  }
  getTargetEngineVersion(): Observable<any> {
    this.setHeaders();
    return this.http.get<string>(this.baseUrl + 'rest/knowledgebase/targetengineversion', this.header);
  }
  getRulesOnId(id: string): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + 'rest/knowledgebase/view/' + id, this.header);
  }
  searchUserDetails(user: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + 'sbdo/get-sbdo-user', user, this.header);
  }
  getUserRoleDetails(getuser: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + 'sbdo/get-user-roles', getuser, this.header);
  }

  setUserRoleDetails(setuser: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + 'sbdo/set-user-roles', setuser, this.header);
  }
  getManageQualifierRoles(): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + 'sbdo/list-of-available-roles/FORD_INTERNAL', this.header);
  }
  getCountryDetails(): Observable<any> {
    console.log(this.baseUrl, 'Base URL country');
    return this.http.get<any>(this.baseUrl + 'sbdo/country-code', this.header);
  }
  getCountryDetailsWithToken(userName: string, userType: string): Observable<any> {
    let username = userName;
    let type = userType;
    let usertype;
    let fdspToken;
    this.rapToken.subscribe((data) => {
      fdspToken = data
    })
    if (type === 'FORD_INTERNAL') {
      usertype = '1';
    }
    else if (type === 'PTS_AFTERMARKET') {
      usertype = '2';
    }
    else {
      usertype = '3';
    }
    const headers = new HttpHeaders()
      .set('USER_TOKEN', `${btoa(username + usertype + ':')}`).set('Authorization', 'Bearer ' + fdspToken);
    console.log(this.baseUrl, 'Base URL country');
    let url: string = this.baseUrl + 'sbdo/country-code';
    return this.http.get<any>(url, {
      headers: headers
    });
  }
  addForMngQualifier(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/role-qualifier-add", req, this.header);
  }
  deleteForMngQualifier(): Observable<any> {
    this.setHeaders();
    return this.http.delete<any>(this.baseUrl + "sbdo/role-qualifier-delete/3", this.header);
  }
  insertAdhocParameters(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/set-adhoc-parameter", req, this.header);
  }
  fetchAdhocParameters(reg: any): Observable<any> {
    this.setHeaders();
    let str = this.baseUrl + "sbdo/get-adhoc-parameter/" + reg.userType + "/" + reg.country
    return this.http.get(str, this.header);
  }
  fetchVin(reg: any): Observable<any> {
    this.setHeaders();
    let str = this.baseUrl + "sbdo/vin2reg/fetchVinDetails?reg=" + reg.registration + "&paCode=" + reg.paCode + "&language=" + reg.language + "&country=" + reg.country
    return this.http.get(str, this.header);
  }
  getTargetEngineTestDetailsApi(vin: string, country: string, language: string): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + 'sbdo/target-engine-test-vehicle/' + vin + '/' + language + '/USA', this.header);
  }
  insertTargetEngineTestDetails(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + 'sbdo/target-engine-test', req, this.header);
  }


  getPatch(sessionId: any): Observable<any> {
    this.setHeaders();
    const headers = this.header;
    return this.http.get<any>(this.baseUrl + "sbdo/manual-diagnostic/" + sessionId, { headers: this.header.headers, responseType: 'text' as 'json' });
  }


  getWDC(userId: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/get-wdc/" + userId, this.header);
  }
  addUpdateWDC(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/set-wdc", req, this.header);
  }

  deleteWDC(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/delete-wdc", req, this.header);
  }

  getRepairPostRepairDetails(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/get-repair-qualification", req, this.header);
  }

  getUserDetails(): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/get-user-details", this.header);
  }


  getRepairDetails(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/getRepairGo", req, this.header);
  }



  getPostRepairDetails(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/getPostRepairGo", req, this.header);
  }



  getContinueDetails(sessionId: any, isClick: boolean): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/getContinue?sessionid=" + sessionId + "&buttonClick=" + isClick,
      this.header);
  }

  getTEPostRepairDetails(vin: any, country: any, language: any, userId: any, username: any, userType: any, sessionId: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/getFaultComponents?vin=" + vin + "&userId=" + username + "&userType=" + userType + "&languageCode=" + language + "&countryCode=" + country + "&sessionId=" + sessionId,
      this.header);
  }
  addSbdRds(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/rds-model-mapping-add", req, this.header);
  }
  getSbdRds(): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/rds-model-mapping-view", this.header);
  }
  deleteSbdRds(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/rds-model-mapping-delete", req,
      {
        headers: this.header.headers,
        responseType: 'text' as 'json'
      });
  }

  updateSbdRds(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/rds-model-mapping-update", req, this.header);
  }
  addOAuth(req: any): Observable<any> {
    this.setHeaders();
    const headers = this.header;
    return this.http.post<any>(this.baseUrl + "sbdo/addCredentials", req, { headers: this.header.headers, responseType: 'text' as 'json' });
  }
  getOAuthServiceRole(): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/getList", this.header);
  }

  getOAuth(userType: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/getCredentials?type=" + userType, this.header);
  }
  deleteOAuth(req: any): Observable<any> {
    this.setHeaders();
    const headers = this.header;
    return this.http.post<any>(this.baseUrl + "sbdo/removeCredential", req, { headers: this.header.headers, responseType: 'text' as 'json' });
  }
  updateOAuth(req: any): Observable<any> {
    this.setHeaders()
    const headers = this.header;
    return this.http.post<any>(this.baseUrl + "sbdo/updateCredential", req, { headers: this.header.headers, responseType: 'text' as 'json' });
  }
  getViewDetailsofFDRS(ruleId: string, language: string, country: string, market: string, candidateType: string, printText: string | null, userName: string, userType: string): Observable<any> {
    let username = userName;
    let type = userType;
    let usertype;
    let fdspToken;
    this.rapToken.subscribe((data) => {
      fdspToken = data
    })
    if (type === 'FORD_INTERNAL') {
      usertype = '1';
    }
    else if (type === 'PTS_AFTERMARKET') {
      usertype = '2';
    }
    else {
      usertype = '3';
    }
    const headers = new HttpHeaders()
      .set('USER_TOKEN', `${btoa(username + usertype + ':')}`).set('Authorization', 'Bearer ' + fdspToken);
    return this.http.get<any>(this.baseUrl + "sbdo/getHtmlDoc?idValue=" + ruleId + "&typeValue=" + candidateType + "&hideclose=true&language=" + language + "&marketCountry=" + market + "&print=" + printText,
      {
        'headers': headers, responseType: 'text' as 'json'
      });
  }

  getViewDetailsofFDRSForTSB(ruleId: string, language: string, country: string, market: string): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/getTsbHtml?print=false&language=en&regionalData=TSB 68/2013&contryCode=US",
      this.header);
  }

  getViewDetailsofFDRSAPI(ruleId: string, seesionId: string): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/getRepairTest?sessionid=" + seesionId + "&SelectedCandidateReference=" + ruleId,
      this.header);
  }

  getViewDetailsofFDRSRedirect(data: any): Observable<any> {
    const userName: string | null = localStorage.getItem("userName");
    const type: string | null = localStorage.getItem("userType");
    const userType: string = type === 'FORD_INTERNAL' ? '1' : type === 'INDEPENDENT' ? '2' : '3';
    const headers = new HttpHeaders().set('Authorization', `Basic ${btoa(userName + userType + ':')}`);
    return this.http.get<any>(data, { headers, responseType: 'text' as 'json' });
  }

  queueIdRes(langunage: string, CountryCode: any, sessionId: any, id: any, candidateType: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/create-queueId?id=" + id + "&appReady=false&clientId=GFDRS&token&installedJREs=notrequired&languageCode=" + langunage + '&candidatetype=' + candidateType, sessionId,
      {
        headers: this.header.headers, responseType: 'text' as 'json'
      });
  }

  secureToken(dealerCode: string, userType: string, languageCode: string, country: string,fdspTokenReqDto : {userName :string}): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/get-fdsp-token/" + dealerCode + "/" + userType + "/" + languageCode + "/" + country, fdspTokenReqDto, this.header);
  }

  isNetworkTestNeeded(vinNumber: any, userTypeID: any, marketCode: string): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/getNetworkTestStatus?vin=" + vinNumber + '&userType=' + userTypeID + '&marketCode=' + marketCode, this.header);
  }


  checkFDRSCompabality(connectedVersion: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/checkFdrsCompatability/version/" + connectedVersion, { headers: this.header.headers, responseType: 'text' as 'json' });
  }

  refreshTopology(sessionId: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/refreshVehicleTopology/sessionId/" + sessionId,
      {
        headers: this.header.headers, responseType: 'text' as 'json'
      });
  }

  postNetworkTest(reqObj: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/insertNetworkTestInfo", reqObj, this.header);
  }

  getServiceList(): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/getList", this.header);
  }

  recurringRule(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/set-Scheduler-Rule", req, this.header);
  }

  offRoadRule(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/updateCredential", req, this.header);
  }

  setViewIndicateComp(obj: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/setViewIndictedComponent", obj, this.header);
  }

  public fdrsConnectionIndicator = new BehaviorSubject<any>('fdrsConn');
  fdrsConnection$ = this.fdrsConnectionIndicator.asObservable();

  sendFDRSStatus(fdrsStatus: any) {
    this.fdrsConnectionIndicator.next(fdrsStatus);
  }

  getVehicleSessions(req: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.idsUrl + "idsfeedback/get-sbdo-session/" + req.vin + "/" + req.userid, this.header);
  }
  getVehicleSessionsV1(req: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.idsUrl + "idsfeedback/get-sbdo-session-v1/" + req.vin + "/" + req.userid + "/" + req.pageNumber + "/" + req.pageSize + '?sessionSource=' + req.sessionSource, this.header);
  }

  getViewSessionsCentralStore(req: any): Observable<any> {
    let fdspToken;
    this.rapToken.subscribe((data) => {
      fdspToken = data
    })
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + fdspToken)
    return this.http.post<any>(this.idsUrl + "idsfeedback/get-view-session", req, { 'headers': headers, responseType: 'text/xml' as 'json' });
  }

  getViewSessions(req: any, userName: string, userType: string): Observable<any> {
    let username = userName;
    let type = userType;
    let usertype;
    let fdspToken;
    if (type === 'FORD_INTERNAL') {
      usertype = '1';
    }
    else if (type === 'PTS_AFTERMARKET') {
      usertype = '2';
    }
    else {
      usertype = '3';
    }
    console.log(username);
    console.log(type)
    this.rapToken.subscribe((data) => {
      fdspToken = data
    })
    const headers = new HttpHeaders().set('USER_TOKEN', `${btoa(username + usertype + ':')}`)
      .set('Authorization', 'Bearer ' + fdspToken)
    return this.http.post<any>(this.baseUrl + "sbdo/get-view-session", req, { 'headers': headers, responseType: 'text/xml' as 'json' });
  }

  getListOfState(): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.idsUrl + "idsfeedback/list_of_state", this.header);
  }

  getWebpageMapping(): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/get-webpage-mapping", this.header);
  }

  getAddAdminRoles(): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + 'sbdo/get-user-roles', this.header);
  }

  resumeSession(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/restore-session", req, this.header);
  }

  renderWiringPage(req: any): Observable<any> {
    return this.http.get<any>("https://wwwqa.fordtechservice.dealerconnection.com/transport/?link=700&params=" + req.vin + "&uid=" + req.uidRef + "&procuid=" + req.procUid,
      {
        headers: new HttpHeaders()
          .set('Authorization', `Basic ${btoa('user:password')}`)
      });
  }

  getAllTask(): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/getTask", this.header);
  }
  addTask(add: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + "sbdo/addTask", add, this.header);
  }
  getTaskParameter(req: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/getTaskParameter?taskId=" + req, this.header);
  }
  runTask(request: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.schUrl + "sbdo/Scheduling/ResponseFastRuleProcessing?taskScheduledId=" + request.taskScheduledId + "&taskId=" + request.taskId + "&userId=" + request.userId,
      this.header);
  }

  runTask1(request: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.schUrl + "sbdo/Scheduling/RegenerateRuleTask?taskScheduledId=" + request.taskScheduledId + "&taskId=" + request.taskId + "&userId=" + request.userId + "&languageCode=" + request.languageCode + "&countryCode=" + request.countryCode,
      this.header);
  }
  runTask2(request: any): Observable<any> {
    this.setHeaders();
    console.log(this.header, "$header$")
    return this.http.get<any>(this.schUrl + "sbdo/Scheduling/FastDeliverableProcedureMappingTask?taskScheduledId=" + request.taskScheduledId + "&taskId=" + request.taskId + "&userId=" + request.userId,
      this.header);
  }

  getschedulecall(request: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.schUrl + "sbdo/scheduler/add", request,
      {
        headers: this.header.headers, responseType: 'text' as 'json'
      });
  }
  deleteTask(del: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + "sbdo/deleteTask", del, this.header);
  }
  deleteTaskParameter(del: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + "sbdo/deleteTaskParameter", del,
      {
        headers: this.header.headers, responseType: 'text' as 'json'
      });
  }
  updateTaskParameter(upd: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + "sbdo/updateTaskParameter", upd,
      {
        headers: this.header.headers, responseType: 'text' as 'json'
      }
    );
  }


  viewRunHistory(view: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + 'sbdo/sbdo-task-history', view, this.header);
  }

  updatePage(req: any): Observable<any> {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/update-page", req, this.header);
  }

  getTaskName(): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + 'sbdo/getTask', this.header);
  }

  getUnselectedSymptomsApi(req: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/unselected-symptoms/" + req, { headers: this.header.headers, responseType: 'text' as 'json' });
  }

  repairQualificationViewBtnClick(sessionId: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/getView?sessionid=" + sessionId, this.header);
  }
  updateScheduledTask(updateSchedule: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.schUrl + "sbdo/update-sbdo-scheduled_task", updateSchedule, this.header);
  }

  noFaultButtonClick(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + 'sbdo/getViewCandidateComplete', req, this.header);
  }
  deleteScheduledTask(deleteSchedule: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + "sbdo/delete-sbdo-scheduled_task", deleteSchedule, this.header);
  }

  faultFoundButtonClick(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + 'sbdo/getViewCandidateComplete', req, this.header);
  }

  diagnosticViewButtonClick(sessionId: any, selectedCandidateRefId: any) {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/viewDiagnostic?sessionid=" + sessionId + "&SelectedCandidateReference=" + selectedCandidateRefId,
      this.header);
  }
  getAllScheduleTask(): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/view-sbdo-scheduled_task", this.header);
  }

  repairPostRepairBtnClick(sessionId: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/getRepairCompleted?sessionid=" + sessionId, this.header);
  }

  repairPostRepairBtnClickForPostRepair(sessionId: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/getRepairCompleted?sessionid=" + sessionId, this.header);
  }

  postRepairTestBtnClick(ruleId: string, seesionId: string): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/getPostRepairTest?sessionid=" + seesionId + "&SelectedCandidateReference=" + ruleId,
      this.header);
  }


  deleteRules(id: any): Observable<any> {
    this.setHeaders();
    const headers = this.header;
    return this.http.post<any>(this.baseUrl + "sbdo/schedule-rule-delete", id, { headers: this.header.headers, responseType: 'text' as 'json' });
  }

  manualBlackOutUpdateApi(req: any): Observable<any> {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/blackout-rule-edit", req, this.header);
  }
  repairCompleteBtnClick(sessionId: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/restart_Diagonsis?sessionId=" + sessionId, this.header);
  }

  cancelBtnClick(sessionId: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/cancel-diagnosis?sessionId=" + sessionId, this.header);
  }


  getAdfsPro(): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/adfs-get-profileList", this.header);
  }
  addAdfsPro(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/adfs-profile-add", req,
      {
        headers: this.header.headers,
        responseType: 'text' as 'json'
      });
  }
  editAdfsPro(id: any, req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/adfs-profile-edit/" + id, req,
      {
        headers: this.header.headers,
        responseType: 'text' as 'json'
      });
  }
  deleteAdfsPro(id: any): Observable<any> {
    this.setHeaders();
    const headers = this.header;
    return this.http.get<any>(this.baseUrl + "sbdo/adfs-profile-delete/" + id, { headers: this.header.headers, responseType: 'text' as 'json' });
  }

  getReports(val: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.automatedUrl + "automation/get-report/" + val, this.header);
  }

  // For Reports above 500 data
  getLargeReports(val: any, offset: any, size: any): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.automatedUrl + `automation/get-report/${val}?offset=${offset}&recordSize=${size}`, this.header);
  }

  getAdfsClient(): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + 'sbdo/adfs-get-client', this.header);
  }
  getAdfsWeb(): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/adfs-get-profile", this.header);
  }

  addAdfsClient(req: any): Observable<any> {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/adfs-client-add", req, this.header);
  }
  addAdfsWeb(req: any): Observable<any> {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/adfs-webservice-add", req, this.header);
  }
  getAdfsWebDeauth(id: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/adfs-webservice-view/" + id, this.header);
  }
  getAdfsWebAuth(id: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/adfs-webservice-unauthorizedClients/" + id, this.header);
  }
  deleteAdfsWeb(id: any): Observable<any> {
    this.setHeaders();
    const headers = this.header;
    return this.http.get<any>(this.baseUrl + "sbdo/adfs-webservice-delete/" + id, { headers: this.header.headers, responseType: 'text' as 'json' });
  }
  editDeauthorize(status: any, req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/adfs-webservice-deauthorized?unauthorized=" + status, req,
      {
        headers: this.header.headers,
        responseType: 'text' as 'json'
      });
  }
  editAuthorize(status: any, req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/adfs-webservice-authorized?authorized=" + status, req,
      {
        headers: this.header.headers,
        responseType: 'text' as 'json'
      });
  }
  editWebserviceAdfs(id: any, req: any): Observable<any> {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/adfs-webservice-edit/" + id, req, this.header);
  }

  getServiceListById(id: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/schedulr-rule-view/" + id, this.header);
  }
  getBlackoutData(id: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/get-Manual-blackout-Rules?serviceId=" + id, this.header);
  }

  editAdfsClient(id: any, req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/adfs-client-edit/" + id, req,
      {
        headers: this.header.headers,
        responseType: 'text' as 'json'
      });
  }
  getAdfsClientView(id: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/adfs-client-view/" + id, this.header);
  }
  deleteAdfsClient(id: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/adfs-client-delete/" + id, this.header);
  }

  ruleUpdateApi(req: any): Observable<any> {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/schedule-rule-edit", req, this.header);
  }
  getGlobalManagedServicesDetails(id: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + 'sbdo/get-services-blackout-roles?serviceIds=' + id, this.header);
  }
  partskitinfo(sessionId: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + 'sbdo/check-parts-kits-support?sessionId=' + sessionId,
      this.header);
  }

  captureEvisDataDetails(vin: string, language: string, country: any, sessionId: any, userId: any) {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + 'sbdo/insertevisdata?vin=' + vin + '&language=' + language + '&country=' + country + '&sessionId=' + sessionId + '&userId=' + userId, this.header)
  }

  getVehicleLines(): Observable<any> {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/get-vehiclelines", this.header);
  }
  featureDeliverList(req: any): Observable<any> {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/get-deliverable-list", req, this.header);
  }
  updateDispName(req: any): Observable<any> {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/update-displayname", req, this.header);
  }
  getOtxStatus(vin: string, appId: string, language: string, country: any, sessionId: any, user: any, userType: any, candidateType: any, state: any, applicationSubmit: boolean, indictedComponentId: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/getOtxStatus?vin=" + vin + "&appId=" + appId + "&userId=" + user + "&state=" + state + "&applicationSubmit=" + applicationSubmit + "&indictedComponentId=" + indictedComponentId + "&userType=" + userType + "&languageCode=" + language + "&countryCode=" + country + "&sessionId=" + sessionId + "&candidateType=" + candidateType, this.header);
  }
  getProperty(id: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/getExtraProperties?id=" + id, this.header);
  }
  addProperty(req: any): Observable<any> {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/addExtraProperties", req, {
      headers: this.header.headers,
      responseType: 'text' as 'json'
    });
  }
  deleteProperty(req: any): Observable<any> {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/removeExtraProperties", req, {
      headers: this.header.headers,
      responseType: 'text' as 'json'
    });
  }
  getRAP(id: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.rapUrl + "GetUserInfo/" + id, this.rapheader)
  }

  UploadRAP(data: any): Observable<any> {
    this.setHeaders()
    const endpoint = this.rapUrl + "SubmitRapConcern";
    // const formData: FormData = new FormData();
    // formData.append('file', data.attachedFile);
    return this.http.post<any>(endpoint, data, this.rapheader);
  }

  skipCandidate(req: any): Observable<any> {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/skipCandidate", req, this.header
    );
  }

  getSkipCandidateStatusFromAdmin(userType: any, market: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/get-adhoc-parameter/" + userType + "/" + market, this.header);
  }
  getEditRule(id: any): Observable<any> {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/schedulr-rule-EditDetails/" + id, this.header);
  }

  getReRunNetworkTestConfiguration(userType: any, market: any) {
    this.setHeaders()
    return this.http.get<any>(this.baseUrl + "sbdo/get-network-test-Count/" + userType + "/" + market, this.header)
  }

  setSystemSnapShotDetails(req: any) {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/setSnapShotDetails", req, this.header);
  }

  getDTCData(Vin: any, userID: any, userType: any, languageCode: any, countryCode: any, dealerCode: any, days: any) {
    let type = userType;
    let usertype;
    let fdspToken;

    this.rapToken.subscribe((token) => {
      fdspToken = token;
    })

    if (type === 'FORD_INTERNAL') {
      usertype = '1';
    }
    else if (type === 'PTS_AFTERMARKET') {
      usertype = '2';
    }
    else {
      usertype = '3';
    }
    const headers = new HttpHeaders().set('USER_TOKEN', `${btoa(userID + usertype + ':')}`)
      .set('Authorization', 'Bearer ' + fdspToken);
    return this.http.get<any>(this.baseUrl + "sbdo/getICurrentDtc?vin=" + Vin + "&userId=" + userID + "&userType=" + userType + "&languageCode=" + languageCode + "&countryCode=" + countryCode + "&dealerCode=" + dealerCode + "&numberOfDays=" + days, { "headers": headers })
  }
  getCandidateDTCRuleDetails(ruleId: string, ruleNumber: string) {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + "sbdo/getRuleDtc?ruleId=" + ruleId + "&ruleNumber=" + ruleNumber, this.header);
  }

  getDummySessionDetails(req: any) {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/session/vehicle-session", req, this.header);
  }

  getDummyViewSessionDetails(req: any, userName: string, userType: string, token: any) {
    let username = userName;
    let type = userType;
    let usertype;
    if (type === 'FORD_INTERNAL') {
      usertype = '1';
    }
    else if (type === 'PTS_AFTERMARKET') {
      usertype = '2';
    }
    else {
      usertype = '3';
    }

    const headers = new HttpHeaders().set('USER_TOKEN', `Basic ${btoa(username + usertype + ':')}`).set('Authorization', 'Bearer ' + token);

    return this.http.post<any>(this.baseUrl + "sbdo/get-dummy-view-session", req, { headers, responseType: 'text/xml' as 'json' });
  }

  getImage(url:any) {
    this.setHeaders()
    return this.http.get<any>(url, {
      headers: this.header.headers, responseType: 'blob' as 'json'
        });
  }

  requestTempDealerCode(req: any): Observable<any> {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/getTempDealerDetails", req, this.header);
  }

  submitTempDealerDetails(req: any) {
    this.setHeaders()
    return this.http.post<any>(this.baseUrl + "sbdo/addUpdateDeleteTempDealer", req, this.header);
  }

  // Whats New API
  // Method to get messages
  // Return type is Observable<BackendMessageResponse[]>
  getWhatsNewMessage(req: { market: string; language: string; days: number }): Observable<BackendMessageResponse[]> {
    this.setHeaders();
    const url = `${this.baseUrl}/sbdo/whats-new/get-message/${req.market}/${req.language}/${req.days}`;
    // Explicitly request the response body
    return this.http.get<BackendMessageResponse[]>(url, { headers: this.header.headers, observe: 'body' as 'body' }).pipe( // Added observe: 'body' explicitly
      catchError(error => {
        console.error("Error in getWhatsNewMessage:", error);
        return throwError(() => new Error(error.message || 'Failed to fetch messages'));
      })
    );
  }

  // Unified method to add message with optional attachment
  // Return type is Observable<BackendMessageResponse[]>
  addMessage(messageRequest: WhatsNewMessageRequest, file: File | null): Observable<BackendMessageResponse[]> {
    this.setHeaders();
    const url = `${this.baseUrl}/sbdo/whats-new/add-message`;

    const formData = new FormData();

    const messageBlob = new Blob([JSON.stringify(messageRequest)], { type: 'application/json' });
    formData.append('message', messageBlob, 'message.json');

    if (file) {
      formData.append('file', file, file.name);
    }

    // Explicitly request the response body
    const options = { headers: this.header.headers, observe: 'body' as 'body' }; // Added observe: 'body'

    return this.http.post<BackendMessageResponse[]>(url, formData, options).pipe(
      catchError(error => {
        console.error("Error in addMessage:", error);
        return throwError(() => new Error(error.error?.message || error.message || 'Failed to add message'));
      })
    );
  }

  // Unified method to update message with optional attachment handling
  // Return type is Observable<BackendMessageResponse>
  updateMessage(id: number, messageRequest: WhatsNewMessageRequest, contextMarket: string, file: File | null): Observable<BackendMessageResponse> {
    this.setHeaders();
    const url = `${this.baseUrl}/sbdo/whats-new/update-message/${id}`;

    const formData = new FormData();

    const messageBlob = new Blob([JSON.stringify(messageRequest)], { type: 'application/json' });
    formData.append('message', messageBlob, 'message.json');

    if (file) {
      formData.append('file', file, file.name);
    }

    let params = new HttpParams();
    if (contextMarket) {
      params = params.append('contextMarket', contextMarket);
    }

    // Explicitly request the response body
    const options = { headers: this.header.headers, params: params, observe: 'body' as 'body' }; // Added observe: 'body'

    return this.http.put<BackendMessageResponse>(url, formData, options).pipe(
      catchError(error => {
        console.error("Error in updateMessage:", error);
        return throwError(() => new Error(error.error?.message || error.message || 'Failed to update message'));
      })
    );
  }

  // Method to delete message
  // Return type is Observable<void>
  deleteWhatsNewMessage(id: number, contextMarket: string): Observable<void> {
    this.setHeaders();
    const url = `${this.baseUrl}/sbdo/whats-new/delete-message/${id}`;

    let params = new HttpParams();
    if (contextMarket) {
      params = params.append('contextMarket', contextMarket);
    }

    // Explicitly request the response body (which is void)
    const options = { headers: this.header.headers, params: params, observe: 'body' as 'body' }; // Added observe: 'body'

    return this.http.delete<void>(url, options).pipe(
      catchError(error => {
        console.error("Error in deleteWhatsNewMessage:", error);
        return throwError(() => new Error(error.error?.message || error.message || 'Failed to delete message'));
      })
    );
  }

  // Method to download attachment file
  // Return type is Observable<Blob>
  getWhatsNewAttachment(filename: string): Observable<Blob> {
    this.setHeaders();
    // Modify the filename for the URL: replace 'whatsnew-attachments/' with 'whatsnew-attachments_'
    let urlFilename = filename;
    if (filename && filename.startsWith('whatsnew-attachments/')) {
      urlFilename = filename.replace('whatsnew-attachments/', 'whatsnew-attachments_');
      console.log(`Modified attachment filename for URL: ${filename} -> ${urlFilename}`); // Log the modification
    }

    // Use the modified filename in the URL
    const url = `${this.baseUrl}/sbdo/whats-new/attachments/${urlFilename}`;
    console.log(`Fetching attachment from URL: ${url}`); // Log the final URL

    // Explicitly request the response body (which is a Blob)
    return this.http.get(url, { responseType: 'blob', headers: this.header.headers, observe: 'body' as 'body' }).pipe(
      catchError(error => {
        console.error("Error in getWhatsNewAttachment:", error);
        return throwError(() => new Error(error.message || 'Failed to download attachment'));
      })
    );
  }


  getDSSHValidateModule() {
    this.setHeaders();
    return this.http.get<any>(this.baseUrl + 'sbdo/restricted-dssh-module/', this.header);
  }

    validateRvc(rvcCode: string, timestamp: string) { // <--- Added timestamp parameter
    console.log(`ApifirstService: Sending RVC code "${rvcCode}" and timestamp "${timestamp}" for validation...`);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const reqBody = {
      rvcCode: rvcCode,
      timestamp: timestamp
    };
    const validationEndpoint = `${this.baseUrl}/api/validateRvcEndpoint`; // <-- **REPLACE THIS URL**
    return this.http.post<any>(validationEndpoint, reqBody, { headers });
  }

  getDSSHRestrictedModule(req: any){
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/restricted-dssh-module", req,this.header);
  }

  validateRvcCode(req:any){
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/validate-rvc", req,this.header)
    }

  uploadGtacTemplate(gtacDto: GtacTemplateDto, file: File): Observable<HttpEvent<any>> {
    this.setHeaders();
    const formData = new FormData();

    const messageBlob = new Blob([JSON.stringify(gtacDto)], {type: 'application/json'});
    formData.append('dto',messageBlob, 'gtacDto.json')

    if (file) {
      formData.append('file', file, file.name);
    }

    return this.http.post(
      this.baseUrl + "sbdo/upload/gtac/template",
      formData,
      {
        headers: this.header.headers,
        reportProgress: true,
        observe: 'events',
        responseType: 'text'
      }
    ).pipe(
      catchError(error => {
        console.error("Error in addMessage:", error);
        return throwError(() => new Error(error.error?.message || error.message || 'Failed to add message'));
      })
    );
  }

  getGtacTemplate(): Observable<any> {
    this.setHeaders();
    return this.http.get(this.baseUrl + 'sbdo/upload/get/gtac/templates', this.header);
  }

  revertTemplate(gtacDto: GtacTemplateDto): Observable<any> {
    this.setHeaders();
    const httpOptions = {
      headers: this.header.headers,
      responseType: 'text' as 'text'
    };
    return this.http.post(this.baseUrl + 'sbdo/upload/gtac/template/revert',gtacDto, httpOptions);
  }

  downloadActiveTemplate(filetype: 'pdf' | 'docx'): Observable<HttpResponse<Blob>> {
    this.setHeaders();
    const url = `${this.baseUrl}sbdo/upload/gtac/template/download/active`;
    return this.http.get<Blob>(url, {
      headers: this.header.headers,
      responseType: 'blob' as any,
      observe: 'response',
      params: { fileType: filetype }
    });
  }

  setShowWhatsNew(value: boolean) {
    this._showWhatsNew.next(value);
  }
  private _hasScrollbar = new BehaviorSubject<boolean>(false);

  hasScrollbar$: Observable<boolean> = this._hasScrollbar.asObservable();
  // Method to update the scrollbar state
  setHasScrollbar(value: boolean): void {
    if (this._hasScrollbar.getValue() !== value) { // Only emit if the value actually changes
      this._hasScrollbar.next(value);
      console.log(`WhatsNewStateService: Scrollbar state updated to ${value}`);
    }
  }

  // Method to get the current immediate value (useful for initial checks)
  getCurrentHasScrollbar(): boolean {
    return this._hasScrollbar.getValue();
  }
  reportdetails(obj:any){
    return this.http.post<any>(this.baseUrl + "sbdo/save-report-info", obj,this.header);

  }

  generateReport(data:any, reportID:any) {
    this.setHeaders();
    return this.http.post(`${this.baseUrl}sbdo/generate-report?reportID=${reportID}`, data, {
      headers: this.header.headers, responseType: 'arraybuffer', observe: 'response'
    });
  }

  generateRvc(request: any, userName:any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(`${this.baseUrl}sbdo/generate-rvc?userName=${userName}`, request,{ headers: this.header.headers, responseType: 'text' as 'json' })
  }

  getComponentSelected(identifyResponse: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + 'sbdo/getComponentSelected', identifyResponse, this.header);
  }


  getRvcsByFilter(payload: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + 'sbdo/fetchRVC', payload , this.header);
  }
  deleteRvc(req: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/deleteRvc", req, this.header);
  }

  setMobileVanSession(data:any){
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/set-mobile-van-session",data,this.header);
  }

  checkExistingMobileSession(data: any): Observable<any> {
    this.setHeaders();
    return this.http.post(this.baseUrl + "sbdo/check-existing-mobile-session", data, this.header);
  }
  updateDealerCode(payload: any): Observable<any> {
    this.setHeaders();
    return this.http.post<any>(this.baseUrl + "sbdo/update-dealercode", payload, this.header);
  }
  getViewMobileVanSessionInfo(req:any):Observable<any>{
     let fdspToken;
    this.rapToken.subscribe((data) => {
      fdspToken = data
    })
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + fdspToken)
    return this.http.post<any>(this.idsUrl + "idsfeedback/get-mobile-van-details", req, { 'headers': headers, responseType:  'json' });
  }
}
